import React, {useEffect, useContext} from 'react';
import styled from 'styled-components/macro';
import { PropSheet, PropSheetTitle, TextField, SelectField, TextAreaField } from './UI';
import EditorContext from '../../modules/contexts/editor';
import { updateNodeType } from '../../modules/libs/lessonLib';

const StepPropSheet = ({ node }) => {
    const editor = useContext(EditorContext);

    const onBlur = (e, field) => {
        editor.updateNodeField(node, field, e.target.value);
        editor.commitNodeUpdate(node);
    };

    return (
        <PropSheet>
            <PropSheetTitle>Step</PropSheetTitle>
            <TextField label='Title' inputRef={input => { if (input) input.value = node.title; }} onBlur={(e) => onBlur(e, 'title')} />
            <TextField label='Step time for auto-play (secs)' inputRef={input => { if (input) input.value = node.stepTime; }} onBlur={e => onBlur(e, 'stepTime')} />
            <SelectField label='Step mode' value={node.stepMode} options={['add', 'replace']} onSelect={e => onBlur(e, 'stepMode')}  />
            <SelectField label='Transition' value={node.transition} options={['cut', 'cross-dissolve']} onSelect={e => onBlur(e, 'transition')}  />
        </PropSheet>
    );
};

export default StepPropSheet;
